import { render } from "./segment-info.vue?vue&type=template&id=dbcbe4b6"
import script from "./segment-info.vue?vue&type=script&lang=js"
export * from "./segment-info.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__